import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from '@ag-grid-community/core';

export interface CustomHeaderCheckboxParams {
  onchange: (params) => void;
  headerCheckboxChecked: boolean;
  headerCheckboxhasIndeterminateState: boolean;
}

@Component({
  standalone: false,
  selector: 'custom-header-checkbox',
  templateUrl: './custom-header-checkbox.component.html',
  styleUrls: ['./custom-header-checkbox.component.scss']
})
export class CustomHeaderCheckboxComponent implements IHeaderAngularComp {
  params!: CustomHeaderCheckboxParams & IHeaderParams;
  private eGui: HTMLElement;

  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }

  agInit(params: any): void {
    this.params = params;
  }

  init(agParams: CustomHeaderCheckboxParams & IHeaderParams) {
    this.params = agParams;
    console.log(this.params);
  }

  onIsMetadataChanged(): void {
    if (this.params.onchange) {
      this.params.onchange(this.params);
    }
  }
}
